module.exports = __webpack_public_path__ + "static/media/ChannelSong.Kannda.37623c1f.jpg";